// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1dVTi","name":"ConsentHeader_name__2By9-","birthday":"ConsentHeader_birthday__XtS3M","skeleton":"ConsentHeader_skeleton___rUKE"};